<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            上账单号：<span v-if="formData.applyNo"
                           style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.applyNo }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information"> 制单</span>
            <span v-else class="information">

              {{
                formData.stat == '0' ? '制单' : formData.stat == '1' ? '申请' : formData.stat == '2' ? '审核' : formData.stat == '3' ? '已发货' : formData.stat == '4' ? '已收货' : formData.stat == '9' ? '驳回' : formData.stat == '98' ? '已结算' : '取消'
              }}</span>

          </div>
          <div style="display:none">

            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">指派中心
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>


          </div>
          <div class="fr">
            <!-- <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button> -->
            <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
          </div>
        </div>



          <!-- 基本信息 -->
          <dix style="overflow-y: scroll!important;
    height: 100vh!important; ">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>主信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      上帐单号
                    </th>
                    <td>
                      <el-input type="text"
                                :disabled="formData.siteId == null"
                                autocomplete="off"
                                v-model="formData.orderNo"
                                clearable :readonly="true">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showOrderPop=true"></i>
                      </el-input>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      上账科目
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.outOrderNo" style="width:  ;"
                                clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      机构名称
                    </th>
                    <td>
                      <el-cascader
                        v-model="orgValue"
                        :options="orgOptions"
                        @change="orgHandleChange"/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      网点
                    </th>
                    <td>
                      <el-input type="text"
                                autocomplete="off"
                                v-model="formData.siteName"
                                clearable :readonly="true">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showSitePop=true"></i>
                      </el-input>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      状态
                    </th>
                    <td>
                      <el-form-item>
                        <el-select v-model="formData.outStat" style="width:  ;" clearable>
                          <el-option label="待审核" :value="1"/>
                          <el-option label="已审核" :value="2"/>
                          <el-option label="驳回" :value="3"/>
                          <el-option label="作废" :value="99"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      金额
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.outOrderNo" style="width:  ;"
                                clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>

                      时间
                    </th>
                    <td>
                      <el-date-picker v-model="formData.checkDate" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00">
                      </el-date-picker>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div class="title first"><b>票据信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      收款银行帐户
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.checkBy" style="width:  ;"
                                clearable/>
                    </td>
                    <th>收款银行帐号</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.checkBy" style="width:  ;"
                                clearable/>
                    </td>
                    <th>
                      收款银行名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.checkBy" style="width:  ;"
                                clearable/>
                    </td>
                  </tr>

                  <tr>
                    <th>
                      付款银行帐户
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.checkBy" style="width:  ;"
                                clearable/>
                    </td>
                    <th>付款银行帐号</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.checkBy" style="width:  ;"
                                clearable/>
                    </td>
                    <th>
                      付款银行名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.checkBy" style="width:  ;"
                                clearable/>
                    </td>
                  </tr>
                    <tr>
                      <th>票据号码</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.checkBy" style="width:  ;"
                                clearable/>
                    </td>
                    <th>手续费</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.checkBy" style="width:  ;"
                                clearable/>
                    </td>
                     <th>实际金额</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.checkBy" style="width:  ;"
                                clearable/>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      支付时间
                    </th>
                    <td>
                      <el-date-picker v-model="formData.applyDate" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00">
                      </el-date-picker>
                    </td>
                    <th>
                      预计到帐时间
                    </th>
                    <td>
                      <el-date-picker v-model="formData.checkDate" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00">
                      </el-date-picker>
                    </td>
                    <th>实际到帐时间</th>
                    <td>
                      <el-date-picker v-model="formData.writeDeliverDate" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00">
                      </el-date-picker>
                    </td>
                  </tr>
                  <tr>
                    <th>图片</th>
                    <td colspan="">
                      <div class="form_picture">
                        <div>
                          <el-upload style="display:flex"
                                     :action="api.uploadFileUrl" :on-remove="handleRemove1" list-type="picture-card"
                                     :file-list="picList1"
                                     :on-success="(res,file, fileList) => {handleSuccess1(res,file, fileList)}"
                                     :on-change="(files, fileList) => {handleImageChange(fileList)}"
                                     :auto-upload="true" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>接口对接</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      传单状态
                    </th>
                    <td>
                      <el-form-item>
                        <el-select v-model="formData.sendFlag" style="width:  ;" clearable>
                          <el-option label="未传" :value="0"/>
                          <el-option label="失败" :value="1"/>
                          <el-option label="已传" :value="2"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <th>
                      传单时间
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.getBy" style="width:  ;"
                                clearable/>
                    </td>

                  </tr>
              <tr><th>
                      传单备注
                    </th>
                    <td colspan="3">
                      <el-input type="text" autocomplete="off" v-model="formData.sendMessage" clearable/>
                    </td></tr>
                  </tbody>
                </table>
              </div>


              <div style="height:0px"></div>
            </div>
          </dix>




      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>

    <sitePop v-if="showSitePop"
             @commit="siteCommit"
             :visiable.sync="showSitePop"
             multi="true"/>

    <orderPop v-if="showOrderPop"
              @commit="orderCommit"
              :visiable.sync="showOrderPop"
              :siteId="formData.siteId"
              multi="true"/>

    <warehousePop v-if="showWarehousePop"
                  @commit="warehouseCommit"
                  :visiable.sync="showWarehousePop"
                  multi="true"/>
  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import warehousePop from '@/views/dialogCommon/radioWarehouseDialog.vue'
import {dictType, loadDictData} from "@/config/dictType";


export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {orderPop, sitePop, warehousePop},
  data() {
    return {
      showSitePop: false,
      showOrderPop: false,
      showWarehousePop: false,
      orgOptions: [],
      orgValue: '',
      areaOption: [],
      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      shippingMethodList: [],
      logisticsCompaniesList: [],
      picList1: [],
      picList2: [],
      picList3: [],
      formData: {
        siteName: null,
        outWarehouseName: null,

        applyNo: null,  // 申请单号;前缀"PA"+年月日+6位流水号
        orgId: 0,  // 所属中心，关联脚手架机构表sys_dept.dept_id
        orgName: null,  // 所属机构名称,冗余字段
        orgIdPath: null,  // 所属机构ID路径,冗余字段.重要
        siteId: null,  // 网点ID,关联sn_user.id;
        stat: 0,  // 单据状态:0制单;1申请;2审核;3已发货;4已收货;9驳回;98已结算;99取消
        outStat: 1,  // 发货状态:0未发货;1部分发货;2完全发货
        getStat: 0,  // 收货状态:0未收货;1部分收货;2完全收货;(只要明细中有一个为部分收货，则表头也为部分收货)
        itemType: 0,  // 物资类型：1维修物资;2非维修物资
        feeType: 0,  // 费用类型:1现金购买;2额度申购
        applyType: 0,  // 申请类型：1储备订单;2加急单
        orderId: 0,  // 工单ID：关联so_order.id;由工单申请配件产生时有值
        orderNo: null,  // 工单号,冗余字段
        outOrderNo: null,  // 外部单号
        outType: 0,  // 发出类型:1总部;2中心
        outWarehouseId: 0,  // 出库仓ID,关联bas_warehouse.id
        deliverProvince: null,  // 省
        deliverCity: null,  // 市
        deliverCounty: null,  // 区
        deliverTown: null,  // 街道
        areaId: 0,  // 地区ID,关联bas_area.id
        deliverAddress: null,  // 配件收货人详细地址
        deliverMan: null,  // 配件收货人姓名
        deliverMobile: null,  // 配件收货人电话
        deliverType: 0,  // 配送方式ID，关联脚手架数据字典项目表sys_dict_item.id
        deliverTypeName: null,  // 配送方式名称,冗余字段
        deliverCompany: 0,  // 物流公司ID，关联脚手架数据字典项目表sys_dict_item.id
        deliverCompanyName: null,  // 物流公司名称,冗余字段
        deliverNo: null,  // 物流单号
        applyQtyAll: 0,  // 总申请数量
        applyAmountAll: 0,  // 总申请金额
        checkQtyAll: 0,  // 总审核数量
        checkAmountAll: 0,  // 总审核金额
        outQtyAll: 0,  // 总发货数量
        outAmountAll: 0,  // 总发货金额
        getQtyAll: 0,  // 总收货数量
        getAmountAll: 0,  // 总收货金额
        diffQtyAll: 0,  // 总差异数量
        diffAmountAll: 0,  // 总差异金额
        applyDate: null,  // 申请时间
        checkDate: null,  // 审核时间
        checkBy: null,  // 审核人
        outDate: null,  // 发货时间
        outBy: null,  // 发货人
        writeDeliverDate: null,  // 填写物流时间
        getDate: null,  // 收货时间
        getBy: null,  // 收货人
        rejectDate: null,  // 驳回时间
        rejectBy: null,  // 驳回人
        cancelDate: null,  // 取消时间
        printNum: 0,  // 打印次数
        sendFlag: 0,  // 传单状态：0未传;1失败;2已传
        sendDate: null,  // 传单时间
        sendMessage: null,  // 传单备注
        pic1: null,  // 图片1
        pic2: null,  // 图片2
        pic3: null,  // 图片3
        spPartsApplyOperationDTOList: []
      },

      show3: false,
      node: true,

      tenant: {
        picList1: [],  // 考核凭证1
        proofAttachment2: '',  // 考核凭证2
        proofAttachment3: '',  // 考核凭证3
        tableData1: [{
          id: 10001,
          name: 'Test1',
          role: 'Develop',
          sex: 'Man',
          age: 28,
          address: 'test abc',
          diffAmount: '1',
          getStat: '未收货',
        },
          {
            id: 10002,
            name: 'Test2',
            role: 'Test',
            sex: 'Women',
            age: 22,
            address: 'Guangzhou',
            diffAmount: '1',
            getStat: '未收货',
          },
          {
            id: 10003,
            name: 'Test3',
            role: 'PM',
            sex: 'Man',
            age: 32,
            address: 'Shanghai',
            diffAmount: '1',
            getStat: '未收货',
          },
          {
            id: 10004,
            name: 'Test4',
            role: 'Designer',
            sex: 'Women',
            age: 23,
            address: 'test abc',
            diffAmount: '1',
            getStat: '未收货',
          },
        ],
        orderNo: '', // 工单号,前缀"SO"+年月日+6位流水号
        createType: 0, // 生成方式：0默认;1客服;2excel;3接口;4公众号;5PC自建单;6APP自建单;7服务中心;9其它;94苏宁帮客;95京东服务市场;97天猫服务市场;98京东测量服务;99京东ue平台;100京东3C
        orderTypeId: 0, // 工单来源ID,关联bas_order_type.id
        serverTypeId: 0, // 服务类型ID,关联bas_service_type.id
        userType: 0, // 用户类型:0普通用户、1售前机、2工程机、3VIP用户、4经销商
        userName: '', // 用户姓名
        userMobile: '', // 来电号码
        userPhone1: '', // 其他号码1
        userPhone2: '', // 其他号码2
        userProvice: '', // 省
        userCity: '', // 市
        userCounty: '', // 县
        userTown: '', // 镇街
        areaId: 0, // 地区ID,关联bas_area.id
        userAddress: '', // 详细地址
        longitude: 0, // 经度
        latitude: 0, // 纬度
        guaranteeType: 0, // 保修类型：1保内、2保外、3未知
        brandId: 0, // 品牌ID,关联sn_company_brand.id
        buyDate: '', // 购买时间
        buyShop: '', // 购买商场
        invoiceNo: '', // 发票号
        brarcode: '', // 报单条码
        outOrderNo: '', // 外部订单号
        complaintTypeId: 0, // 客诉类型ID,关联bas_customer_complaint_type.id
        issueFaultId: 0, // 客服录单故障现象id,关联bas_fault_symptom.id
        appeals: '', // 述求
        stat: 0, // 状态：1登记;2发布;5已派网点;9已派师傅;13已出发;17已上门;20完工暂存;21已完工;22网点确认完工;23中心确认完工;24总部确认完工;91待结算;92结算驳回;93结算中止;94已结算;98挂起;99取消
        dispatchStat: '', // 工单标签
        partsStat: 0, // 配件状态：0无配件;1申请；2审核；3出库；4网点收货；8驳回；9取消；11更换；12网点返厂；13返厂确认
        recallStat: 0, // 回访状态：0未回访、1已抽样、2已回访;5用户已评价
        siteComplainStat: 0, // 申诉状态：0无申诉；3待申诉；5已申诉；7中心已审核；8中心驳回；9总部已处理；99取消
        qualityStat: 0, // 质检状态：0未质检；1质检通过；2质检不通过；
        orgId: 0, // 业务机构，关联脚手架机构表sys_dept.dept_id
        orgName: '', // 机构名称,冗余字段
        orgIdPath: '', // 机构ID路径,冗余字段.重要
        siteId: 0, // 网点ID,关联sn_user.id;
        siteName: '', // 网点名称,冗余字段
        engineerId: 0, // 工程师Id,关联sn_site_engineer.id
        engineerName: '', // 工程师名称,冗余字段
        openId: '', // 消费者报修时关联的微信号id
        sysmtomId: 0, // 故障现象id,关联bas_fault_symptom.id
        reasonId: 0, // 故障原因id,关联bas_fault_reason.id
        methodId: 0, // 维修措施id,关联bas_fix_method.id
        isMustRecall: 0, // 是否必访:0否1是
        isCallRecall: 0, // 是否可抽样:0否1是
        isUrgent: 0, // 是否急单:0否1是
        isReplaceFinish: 0, // 是否重新完工：0否1是
        urgeTimes: 0, // 催单次数
        complainTimes: 0, // 投诉次数
        managerId: 0, // 督办人,关联sys_user.id
        outTransIn: 0, // 申请保外转保内:0否1是
        settleId: 0, // 结算单ID,关联sf_batch_settle.id字段
        sendPay: '', // sendPay:打标标识，未定义
        serverTypeName: null,
        orderTypeName: null,
        symptomName: null,
        reasonName: null,
        methodName: null,

        soOrderExtendDTO: {
          wishBookDate: '', // 期望上门/安装时间
          deliverTime: '', // 到货签收时间
          finishMode: 0, // 完工模式：1结算密码；2上传图片；3图片+条码；9无验证完工
          finishType: 0, // 完工方式:1总部代完工;2网点PC端完工;3网点APP完工;4师傅APP完工;5接口完工;9其他
          commentLevel: 0, // 短信满意度：1非常满意;2满意;3一般;4不满意;5非常不满意
          isSendCommentMessage: 0, // 是否已发送评价短信：0否1是
          qualityMan: '', // 质检人
          qualityDate: '', // 质检时间
          qualityRemark: '', // 质检备注
          secondSiteComplain: 0, // 是否二次申诉：0否1是
          isInstallSynchro: 0, // 是否送装同步：0否1是
          hangupType: 0, // 挂起类型：0总部挂起；1网点挂起
          hangupReason: '', // 挂起原因
          sendFlag: 0, // 外部系统传单标识:0未传;1失败;2已传
          sendMessage: '', // 外部系统传单返回信息
          sendDate: '', // 外部系统传单时间
          thirdSendFlag: 0, // 传第三方网点接口状态:0未传;1失败;2已传
          thirdSendDate: '', // 传第三方网点接口时间
          thirdSendMessage: '', // 传第三方网点接口备注,如失败时用来保存失败的原因
          tmfworderid: '', // 天猫服务市场的工单ID
          tbcustomerid: '', // 天猫服务市场的用户ID
          commercePraise: 0, // 是否电商好评：0否1是
        },
        soOrderProcessDTO: {
          orderId: 0, // 工单id，关联so_order.id
          takeOrgTime: '', // 派中心时间
          takeTime: '', // 派单时间
          acceptOperateTime: '', // 网点确认接单时间
          takeEngineerTime: '', // 派工程师时间
          engineerAcceptOperateTime: '', // 工程师确认接单时间
          firstBookOperateTime: '', // 首次预约操作时间
          firstBookDate: '', // 首次预约时间
          bookOperateTime: '', // 预约操作时间
          bookDate: '', // 预约时间
          startOffTime: '', // 出发时间
          onDoorTime: '', // 上门签到时间
          onDoorLocation: '', // 上门签到地址
          firstCompleteTime: '', // 首次完工时间
          completeTime: '', // 完工时间
          onTimeLocation: '', // 完工地址
          siteComfirmTime: '', // 网点确认完工时间
          orgComfirmTime: '', // 中心确认完工时间
          officeComfirmTime: '', // 总部确认完工时间
          recallTime: '', // 回访时间
          complaintProcessTimes: 0, // 客诉跟进次数
          complaintProcesser: '', // 客诉跟进人
          complaintProcessDate: '', // 客诉跟进时间
          siteComplaintProcessDate: '', // 网点客诉跟进时间
          applyPayDate: '', // 进入结算池时间
          payDate: '', // 提交结算时间
          cancleDate: '', // 取消/退单时间
          returnId: 0, // 取消/退单原因：关联bas_return_type.id.
          finishNote: '', // 完工备注
          comfirmNote: '', // 完工审核备注
        },
        soOrderCommentDTO: {
          orderId: 0, // 工单id，关联so_order.id
          speed: 0, // 响应速度评分
          effect: 0, // 服务效果评分
          fee: 0, // 收费评分
          other: '', // 其他评论
          pic1: '', // 图片1
          pic2: '', // 图片2
          pic3: '', // 图片3
          topLevel: 0, // 总体评价:1非常满意;2满意;3一般;4不满意;5非常不满意
          sources: 0, // 评价来源:1电商接口;2短信回复评价;3用户微信评价
        },
        soOrderSettleDTO: {
          siteFinalAmount: null,
          siteAmount: null,
          rewardAmount: null,
          mapLongDistance: null,
          longDistance: null,
          longDistanceAmount: null,
          userPayType: null,
          userPayName: null,
          userPayAccount: null,
          userPayStat: null,
          userPayNo: null,
          userPayTime: null,
          userPayStatMsg: null,
          productDate: null,
          installDate: null
        },
        soOrderSpecailFeeDTO: {
          amount: null
        },
        soOrderResultDTO: {
          inCode: null,
          outCode: null,
          finishPic1: null,
          finishPic2: null,
          finishPic3: null,
          finishPic4: null,
          finishPic5: null,
          finishPic6: null,
        },
        soOrderComplainDTOList: [],
        soOrderLineDTOList: [],
        soOrderPartsDTOList: [],
        soOrderPreconditionResultDTOList: [],
        soOrderOperationDTOList1: [],
        soOrderOperationDTOList2: [],
        soOrderOperationDTOList3: [],
        soOrderOperationDTOList4: [],
      },
      srcList: [],


      ////////////////////////////////////////////////////////////////////////////////////////////


      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    this.getData()
    this.loadOrgData()
    this.loadDictData()
  },
  watch: {
    picList1: {
      handler(newVal, oldVal) {
        this.formData.pic1 = uploadFileFormat(newVal)
        console.log(this.formData)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList2: {
      handler(newVal, oldVal) {
        this.formData.pic2 = uploadFileFormat(newVal)
        console.log(this.formData)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList3: {
      handler(newVal, oldVal) {
        this.formData.pic3 = uploadFileFormat(newVal)
        console.log(this.formData)
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.deliverType': {
      handler(newVal) {
        if (newVal !== null && newVal !== undefined) {
          this.shippingMethodList.forEach(item => {
            if (newVal === item.value) {
              this.formData.deliverTypeName = item.label
            }
          })
        }
      },
      deep: true
    },
    'formData.deliverCompany': {
      handler(newVal) {
        if (newVal !== null && newVal !== undefined) {
          this.logisticsCompaniesList.forEach(item => {
            if (newVal === item.value) {
              this.formData.deliverCompanyName = item.label
            }
          })
        }
      },
      deep: true
    }
  },
  methods: {

    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      // 物流公司
      loadDictData(dictType.logisticsCompanies).then(res => {
        this.logisticsCompaniesList = []
        res.data.data.forEach(item => {
          this.logisticsCompaniesList.push({
            label: item.label,
            value: item.id
          })
        })
      })

      // 运输方式
      loadDictData(dictType.shippingMethod).then(res => {
        this.shippingMethodList = []
        res.data.data.forEach(item => {
          this.shippingMethodList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },


    // 仓库弹框选中
    warehouseCommit(data) {
      console.log('选中的仓库', data)
      this.formData.outWarehouseId = data.warehouseId
      this.formData.outWarehouseName = data.warehouseName
    },

    // 工单弹框选中
    orderCommit(data) {
      console.log('选中的工单', data)
      this.formData.orderId = data.orderId
      this.formData.orderNo = data.orderNo
    },

    // 网点弹框选中
    siteCommit(data) {
      console.log('选中的网点', data)
      this.formData.siteId = data.id
      this.formData.siteName = data.name
    },

    // 加载机构数据
    loadOrgData() {
      this.$http({
        url: api.sysDept.getDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        console.log(res.data.data)
        this.orgOptions = []
        res.data.data.forEach(item => {
          let temp = {
            value: item.id,
            label: item.name,
          }
          if (item.hasChild) {
            temp.children = []
            item.child.forEach(item1 => {
              temp.children.push({
                value: item1.deptId,
                label: item1.name
              })
            })
          }
          this.orgOptions.push(temp)
        })
      })
    },

    // 机构选中
    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })
      }
    },

    // 地址选中事件
    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.country = areaNode[0].label;
          this.formData.deliverProvince = null;
          this.formData.deliverCity = null;
          this.formData.deliverCounty = null;
          this.formData.deliverTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.deliverProvince = areaNode[0].label;
          this.formData.deliverCity = null;
          this.formData.deliverCounty = null;
          this.formData.deliverTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.deliverCity = areaNode[0].label;
          this.formData.deliverTown = null;
          this.formData.deliverCounty = null;
        } else if (areaNode[0].level == 4) {
          this.formData.deliverCounty = areaNode[0].label;
          this.formData.deliverTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.deliverTown = areaNode[0].label;
        }
        this.formData.areaId = areaNode[0].value
      } else {
        this.formData.areaId = null;
        this.formData.country = null;
        this.formData.deliverProvince = null;
        this.formData.deliverCity = null;
        this.formData.deliverCounty = null;
        this.formData.deliverTown = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId !== null && this.formData.areaId !== '' && this.formData.areaId != 0) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: {id: this.formData.areaId}
        }).then(res => {
          console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },


    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            var url = (this.isEdit ? api.spPartsApplyHeader.updateDataUrl : api.spPartsApplyHeader.addDataUrl);
            this.$http({
              url: url,
              method: 'post',
              data: this.formData,
              isLoading: true,
            }).then(response => {
              this.$message.success("保存成功！");
              this.$emit('editViewDataUpdate')
              this.$baseReload()
            });
          });
        }
      });
    },

    getData() {
      console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.spPartsApplyHeader.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          if (data.spPartsApplyOperationDTOList === null || data.spPartsApplyOperationDTOList === undefined) {
            data.spPartsApplyOperationDTOList = []
          }
          this.formData = data
          this.picList1 = echoFileFormat(data.pic1)
          this.picList2 = echoFileFormat(data.pic2)
          this.picList3 = echoFileFormat(data.pic3)
          this.orgValue = data.orgId
          this.echoAddress()
        })
      } else {
        this.enabled = true;
      }
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = echoFileFormat(res.data.url)
    },
    handleRemove2() {
      this.picList1 = []
    },
    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = echoFileFormat(res.data.url)
    },
    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = echoFileFormat(res.data.url)
    },


    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },

    areaconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_area;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            areaName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_area = this.table_area.concat(items);
      }
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },
    // 删除所选的数据  2表
    handleDelete1_2(index) {
      this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    },
    AddListRow1_2() {

      this.tenant.snCompanyOrderAttributeDTOS.push({})
    },
    // 上传成功
    handleSuccess(response, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

    },
    handleRemove(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn = false;
    },

    // 上传成功
    handleSuccess4(res, file, picIndex) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn4 = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      Vue.set(this.tenant.businessPhoto,)

    },
    handleRemove4(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn4 = false;
    },
    handleDelete2(index) {
      this.table_area.splice(index, 1);
    },
    handleDelete(index) {
      this.table_type.splice(index, 1);
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}


// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

#containt .title {
  /* border-top: solid 2px #E9E9E9; */
  position: relative;
  padding: 0px !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}

#containt .title b {
  font-size: 12px !important;
}

// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 7vw !important;
}

#containt .table-detail tbody tr td {
  width: 12vw !important;;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}
#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}
</style>
